import { Component, ViewChild } from "@angular/core";
import { MenuItem } from "primeng/api";
import { ContextMenu } from "primeng/contextmenu";
import { ContextMenuService } from "../../services/shared/context-menu-service";

// PrimeNG's ContextMenu leave animation is 100ms. When it completes it clears the z-index and
// global listeners of whatever container is current, so a menu shown before it finishes ends up
// rendered behind the grid and stops responding to outside clicks.
const HIDE_ANIMATION_MS = 150;

@Component({
    standalone: false,
    selector: "app-context-menu",
    templateUrl: "./app-context-menu.component.html",
})
export class AppContextMenuComponent {
    private contextMenuService: ContextMenuService;
    @ViewChild("contextMenu") private contextMenu: ContextMenu;

    menuItems: MenuItem[] = [];
    private hiddenAt = 0;
    private showTimeout: any;

    constructor(contextMenuService: ContextMenuService) {
        this.contextMenuService = contextMenuService;
    }

    ngOnInit() {
        this.contextMenuService.show = this.show.bind(this);
        this.contextMenuService.close = this.close.bind(this);
    }

    show(event: MouseEvent, menuItems: MenuItem[]) {
        clearTimeout(this.showTimeout);
        this.menuItems = menuItems;

        // Already open: keep the same overlay and just reposition it once the new items have rendered
        if (this.contextMenu.visible()) {
            this.showTimeout = setTimeout(() => this.contextMenu.show(event));
            return;
        }

        var delay = Math.max(0, HIDE_ANIMATION_MS - (Date.now() - this.hiddenAt));
        this.showTimeout = setTimeout(() => this.contextMenu.show(event), delay);
    }

    close() {
        clearTimeout(this.showTimeout);
        this.contextMenu.hide();
    }

    onHide() {
        this.hiddenAt = Date.now();
    }
}
